import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Feedbacks = () => import('@/pages/Feedbacks')

export default [
  {
    path: '/feedbacks',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Feedbacks',
        redirect: 'pending' },
      {
        path: 'pending',
        name: 'FeedbacksPending',
        component: Feedbacks,
        props: route => ({
          page: (parseInt(route.query.page, 10) || 1),
          status: 'pending'
        })
      },
      {
        path: 'accepted',
        name: 'FeedbacksAccepted',
        component: Feedbacks,
        props: route => ({
          page: (parseInt(route.query.page, 10) || 1),
          status: 'accepted'
        })
      },
      {
        path: 'rejected',
        name: 'FeedbacksRejected',
        component: Feedbacks,
        props: route => ({
          page: (parseInt(route.query.page, 10) || 1),
          status: 'rejected'
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/feedbacks.route.js